export enum ELOCAL_STORAGE_KEY {
  CONTENT = "contentView",
  COLUMN_FILTERS = "unitedColumnFilters",
  FILTER_DATA = "filterListViewData",
  ARCHIVED_COMPANIES_FILTER_DATA = "archivedCompaniesFilterData",
  COMPANIES_PAGE_PARAMS = "companiesPageParams_20.8",
  PIPELINE = "pipeline"
}

export const companyStatus: { [key: string]: string } = {
  PreSeed: "Pre-Seed",
  Seed: "Seed",
  SeriesA: "Series A",
  SeriesB: "Series B",
  SeriesC: "Series C",
  SeriesD: "Series D",
  SeriesEPlus: "Series E+",
  Private: "Private",
  PrivateEquity: "Private",
  Undetermined: "Undetermined",
  DebtFinancing: "Debt Financing",
  IpoPublicMarket: "IPO/Public Market",
  MergePrivateAcquisition: "Merge/Private Acquisition",
  OutOfBusiness: "Out of Business",
  Grant: "Grant"
};

export const innoveraLogoSrc = "/innovera-red.svg";
export const MINIMUM_COMPANY_FOUNDING_YEAR = 1800;
